import './Main.scss';
import './Form/Form';
import 'Packages/Plugins/GesagtGetan.Inquiry/Resources/Public/JavaScript/SpamProtection';

/**
 * Do not simply disable the submit button. There are other ways to submit a form.
 * https://gomakethings.com/dont-disable-buttons/
 */
document.querySelectorAll('form#inquiryForm').forEach((form) => {
    if (form instanceof HTMLFormElement) {
        form.addEventListener('submit', (event) => {
            if (form.hasAttribute('data-submitting')) {
                event.preventDefault();

                return false;
            }
            form.setAttribute('data-submitting', '');
        });
    }
});
